module.exports = __webpack_public_path__ + "static/media/full-background.e86fb792.svg";